import {
    RESET_STATE,
    FETCH_IDENTIFIERS, FETCH_TEMPLATES, FETCH_SINGLE_TEMPLATE, STORE_TEMPLATE, DELETE_TEMPLATE, UPDATE_TEMPLATE
} from "./types";
import {initialState} from "./state";
import {
    addTemplate,
    deleteTemplate,
    fetchTemplates,
    fetchTemplateDetails,
    updateTemplate,
    fetchIdentifiers
} from "../repository";

import SystemNotificator from "../../../../services/SystemNotificator";

export default {
    [RESET_STATE]({state}) {
        Object.assign(state, initialState());
    },

    [FETCH_IDENTIFIERS]({state}) {
        return fetchIdentifiers()
            .then(({data}) => {
                state.identifiers = data;
            })
    },

    [FETCH_TEMPLATES]({state}) {
        return fetchTemplates()
            .then(({data}) => {
                state.templates = data;
            })
            .catch(({errors}) => {
                SystemNotificator.error({
                    title: 'Błąd pobierania szablonów',
                    message: errors.join(', ')
                });
            })
    },

    [FETCH_SINGLE_TEMPLATE](context, uuid) {
        return fetchTemplateDetails(uuid);
    },

    [STORE_TEMPLATE]({state, commit}, {payload, isNew}) {
        let promise;
        if (false === isNew && !payload.uuid) {
            promise = Promise.reject({})
        } else {
            promise = isNew
                ? addTemplate(payload)
                : updateTemplate(payload.uuid, payload);
        }
        return promise
            .then(async ({data}) => {
                // template collection update
                if (isNew) {
                    state.templates.push({
                        ...payload,
                        uuid: data.uuid
                    })
                } else {
                    commit(UPDATE_TEMPLATE, payload)
                }

                SystemNotificator.success({
                    title: isNew ? 'Szablon został utworzony' : 'Szablon został zaktualizowany',
                });
            })
            .catch((error) => {
                SystemNotificator.error({
                    title: error.status === 403 ? 'Brak uprawnień do edycji' : 'Błąd podczas zapisu szablonów',
                    message: ''
                });
            })
    },

    [DELETE_TEMPLATE]({state}, uuid) {
        return deleteTemplate(uuid)
            .then(async () => {
                    // remove item from state collection
                    state.templates = state.templates.filter(template => template.uuid !== uuid);
                    state.activeTemplateUuid = null;
                    SystemNotificator.success({
                        title: 'Szablon został usunięty'
                    })
                })
            .catch((error) => {
                SystemNotificator.error({
                    title: error.status === 403 ? 'Brak uprawnień' : 'Błąd podczas zapisu szablonów',
                    message: ''
                });
            })
    }
}